export default __webpack_public_path__ + "static/media/ads.d87b166a.svg";